import React from 'react';
import { Badge, BadgeProps } from '@companycam/slab-web';

import { translate } from 'translations/i18n';

type NewBadgeProps = Pick<BadgeProps, 'className' | 'testId'>;

export const NewBadge = ({ className, testId }: NewBadgeProps) => {
  return (
    <Badge color="caution" size="small" className={className} testId={testId}>
      {translate('common.new')}
    </Badge>
  );
};
